<template>
    <div id="delete-item-modal-container" class="bg-white sm:bg-clip-padding sm:bg-black sm:backdrop-filter sm:backdrop-blur-md sm:bg-opacity-60" v-if="!hidden" :class="{opened: !hidden}">

      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
        <div>
          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
            <!-- Heroicon name: outline/check -->
            <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
              {{ title }}
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                {{ description }}
              </p>
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button @click.prevent="confirmModal()" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:col-start-2 sm:text-sm">
            Confirm Deletion
          </button>
          <button @click.prevent="closeModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand sm:mt-0 sm:col-start-1 sm:text-sm">
            Cancel
          </button>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                hidden: true,
                title: 'Delete Modal Title',
                description: 'Here is the description for a deletion modal.',
                confirmationFunction: function () {
                }
            }
        },
        computed: {},
        methods: {
            closeModal() {
                this.title = '';
                this.description = '';
                this.hidden = true;
                this.confirmationFunction = function () {
                };
            },
            confirmModal() {
                this.confirmationFunction();
                this.closeModal();
            },
            openModal() {
                this.hidden = false;
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('delete-modal-open', function (title, description, confirmationFunction) {
                that.title = title;
                that.description = description;
                that.confirmationFunction = confirmationFunction;
                that.openModal();
            });

            eventBus.$on('delete-modal-confirmed', function () {
                that.confirmationFunction();
                that.closeModal();
            });

            eventBus.$on('delete-modal-closed', function () {
                that.closeModal();
            });

        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/setup';

    #delete-item-modal-container {
        display: none;
        &.opened {

            position: absolute;
            height: 100vh;
            width: 100vw;
            z-index: 1000000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

</style>
